    export enum WeeklyPlanningWriteCase
    {
        Always = 1,
        OnChange = 2
    }

    export enum WeeklyPlanningResetKind
    {
        None = 0,
        AtTime = 1,
        AfterMinutes = 2
    }

    export enum WeeklyPlanningButtonsActions {
        ChangeColor = 0,
        ChangeValue = 1,
        NewSlice = 2
    }